import { IViewer, LoginContext } from '../../lib/utils'
import React, {
  useContext,
  useEffect,
  useState,
  Dispatch,
  SetStateAction
} from 'react'
import * as PopupStyles from './BPTLButton.module.scss'
import { NationalPosts } from '../../types'
import { enterReaderTreat } from '../../api/readertreats'
import { bptlVote } from '../../api/votebptl'
import { MULTISITE_COUNTIES } from '../../lib/data/Sites'

interface EnterRTProps {
  loggedIn: boolean
  county: string
  siteId: number | null
  usr?: IViewer | undefined
  userEmail: string
  setPopup: Dispatch<SetStateAction<string | undefined>>
}

interface CastVoteProps {
  loggedIn: boolean
  post: NationalPosts
  userEmail: string
  setUserEmail: Dispatch<SetStateAction<string>>
  setPopupScreen: Dispatch<SetStateAction<number>>
  catName: string
}

interface PopupProps {
  post: NationalPosts
  setShowPopup: Dispatch<SetStateAction<string | undefined>>
  siteId: number | null
  catName: string
}

export const EnterRT = ({
  loggedIn,
  county,
  siteId,
  userEmail,
  setPopup
}: EnterRTProps) => {
  const rtId = 67505
  const [marketingConsent, setMarketingConsent] = useState<boolean>(false)
  const [newsletterConsent, setNewsletterConsent] = useState<boolean>(loggedIn)
  const [loading, setLoading] = useState<boolean>(false)
  const [rtError, setRtError] = useState<string | undefined>()
  const [submitted, setSubmitted] = useState<boolean>(false)
  const [site, setSite] = useState<string>('')

  const handleEnter = () => {
    setLoading(true)
    const rtData = {
      id: rtId,
      data: {
        emailaddress: userEmail,
        county: siteId ? siteId.toString() : '1',
        question: 'Reader Vote Entrant',
        consent: marketingConsent ? '1' : '0',
        name: userEmail
      }
    }

    enterReaderTreat(rtData)
      .then(response => {
        if (response.success === false) {
          setRtError(response.data)
        } else {
          setSubmitted(true)
        }
      })
      .catch(() => setRtError('There was a problem entering this treat'))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    const site = MULTISITE_COUNTIES.filter(c => c.id === siteId)
    setSite(site.length > 0 && site[0].shortName ? site[0].shortName : county)
  }, [])

  return (
    <>
      <div className={PopupStyles.TextBlock}>
        <p className={PopupStyles.Pink}>Thank you for voting!</p>
        <p>
          Now want the chance to get your mitts on £500 to spend at John Lewis
          courtesy of Strutt & Parker?
        </p>
        <p>Enter below in seconds for your chance to win.</p>
      </div>
      <div className={PopupStyles.RTVotingBox}>
        <div className={PopupStyles.SideImage}>
          <img
            src={`/images/best-places-to-live/rt.jpg`}
            alt="£500 worth of John Lewis vouchers"
          />
        </div>
        <div className={PopupStyles.RTForm}>
          {!submitted ? (
            <>
              {!loggedIn && (
                <div className={PopupStyles.Checkbox}>
                  <input
                    onChange={e => setNewsletterConsent(e.target.checked)}
                    type="checkbox"
                    name="newsletterOptIn"
                    value={county}
                    id="newsletterOptIn"
                  />
                  <label htmlFor="newsletterOptIn">
                    I understand that by entering a Reader Treat I will
                    automatically be subscribed to the {site} mailing list.
                    Reader Treats are exclusive to Muddy Stilettos subscribers.
                  </label>
                </div>
              )}
              <div className={PopupStyles.Checkbox}>
                <input
                  onChange={e => setMarketingConsent(e.target.checked)}
                  type="checkbox"
                  name="dataOptIn"
                  value=""
                  id="dataOptIn"
                />
                <label htmlFor="dataOptIn">
                  I would like to be sent news and offers from Strutt & Parker
                </label>
              </div>
              <button
                className={PopupStyles.Button}
                disabled={!newsletterConsent}
                onClick={handleEnter}
              >
                {loading ? 'Submitting...' : 'Click to enter prize draw'}
              </button>
            </>
          ) : (
            <>
              {!rtError ? (
                <p>
                  Thank you! You&apos;ve entered! &nbsp;
                  <span
                    className={PopupStyles.ReturnToContent}
                    onClick={() => setPopup(undefined)}
                  >
                    Continue browsing Muddy Stilettos {site}!
                  </span>
                </p>
              ) : (
                <p className={PopupStyles.Error}>{rtError}</p>
              )}
            </>
          )}
        </div>
      </div>
      {!submitted && (
        <div className={PopupStyles.TextBlock}>
          <p>
            <strong>Need to know</strong>
          </p>
          <ul>
            <li>
              Read our full{' '}
              <a
                target="_BLANK"
                title="Competition Terms & Conditions - Opens in a new window"
                href={`https://muddystilettos.co.uk/competitions-offers-terms-conditions/`}
                rel="noreferrer"
              >
                Reader Treats Terms & Conditions
              </a>{' '}
              here
            </li>
            <li>Entrants must be UK residents </li>
            <li>Competition closes at 11.59pm on 31 March 2023 </li>
            <li>
              Once notified by email, the winner will have 48 hours to accept
              the prize
            </li>
            <li>Prize cannot be exchanged for cash</li>
            <li>Only one entry per person per county allowed</li>
            <li>Subject to availability</li>
          </ul>
        </div>
      )}
    </>
  )
}

const CastVote = ({
  post,
  loggedIn,
  setUserEmail,
  userEmail,
  setPopupScreen,
  catName
}: CastVoteProps) => {
  const [error, setError] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState<boolean>(false)
  const [submitted, setSubmitted] = useState<boolean>(false)
  const [buttonText, setButtonText] = useState<string>('')
  const [consent, setConsent] = useState<boolean>(false)
  const handleSubmit = () => {
    setLoading(true)
    const bptlData = {
      data: {
        emailaddress: userEmail,
        county: catName,
        town: post.title?.replace('Best Places to Live: ', '') ?? '',
        consent: consent ? 'yes' : 'no'
      }
    }
    bptlVote(bptlData)
      .then(response => {
        setSubmitted(true)
        if (response.success === false) {
          throw new Error(response.data.message)
        } else {
          setPopupScreen(1)
        }
      })
      .catch(e => setError(e.message))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (loading) {
      setButtonText('Submitting...')
    } else {
      setButtonText(
        `Vote for ${post.title?.replace('Best Places to Live:', '')}`
      )
    }
  }, [loading])

  const updateEmailAddress = (add: string) => {
    setUserEmail(add)
    submitted && setSubmitted(false)
  }
  return (
    <>
      <p>
        <strong>
          Have your say! Vote for{' '}
          {post.title?.replace('Best Places to Live: ', '')}.
        </strong>
      </p>
      {loggedIn ? (
        <>
          <p>Cast your vote by clicking on the button below:</p>
          <div className={PopupStyles.InputWrapperColumn}>
            <div>
              <input
                type="checkbox"
                name="consent"
                checked={consent}
                onChange={e => setConsent(e.target.checked)}
                id="consent"
              />
              <label htmlFor="consent">
                I would like to be sent news and offers from Knight Frank.
              </label>
            </div>
            <button
              disabled={submitted}
              data-auto="true"
              className={PopupStyles.Button}
              onClick={handleSubmit}
            >
              {buttonText}
            </button>
          </div>
        </>
      ) : (
        <>
          <p>Cast your vote by entering your email address below:</p>
          <div className={PopupStyles.InputWrapperColumn}>
            <input
              type="text"
              name="emailaddress"
              onChange={e => updateEmailAddress(e.target.value)}
              placeholder="Your email address"
            />
            <div>
              <input
                type="checkbox"
                name="consent"
                checked={consent}
                onChange={e => setConsent(e.target.checked)}
                id="consent"
              />
              <label htmlFor="consent">
                I would like to be sent news and offers from Knight Frank.
              </label>
            </div>
            <button
              disabled={submitted}
              className={PopupStyles.Button}
              onClick={handleSubmit}
            >
              {buttonText}
            </button>
          </div>
        </>
      )}
      {error && <p>{error}</p>}
    </>
  )
}

const ThankYou = ({
  siteId,
  county,
  setPopup
}: {
  siteId: number
  county: string
  setPopup: Dispatch<SetStateAction<string | undefined>>
}) => {
  const [site, setSite] = useState<string>('')
  useEffect(() => {
    const site = MULTISITE_COUNTIES.filter(c => c.id === siteId)
    setSite(site.length > 0 && site[0].shortName ? site[0].shortName : county)
  }, [])
  return (
    <>
      <div className={PopupStyles.TextBlock}>
        <p className={PopupStyles.Pink}>Thank you for voting!</p>
        <p>
          Your vote has been counted!{' '}
          <span
            className={PopupStyles.ReturnToContent}
            onClick={() => setPopup(undefined)}
          >
            Continue browsing Muddy Stilettos - {site}!
          </span>
        </p>
      </div>
    </>
  )
}

const Popup = ({ post, setShowPopup, siteId, catName }: PopupProps) => {
  const [loggedIn, setLoggedIn] = useState<boolean>(false)
  const [popupScreen, setPopupScreen] = useState<number>(0)
  const [userEmail, setUserEmail] = useState<string>('')
  const { usr } = useContext(LoginContext)
  const [site, setSite] = useState<string>('')

  useEffect(() => {
    if (usr && usr.viewer?.hasOwnProperty('name')) {
      setLoggedIn(true)
      setUserEmail(usr.viewer.email ?? '')
    }
  }, [usr])

  useEffect(() => {
    const site = MULTISITE_COUNTIES.filter(c => c.id === siteId)
    setSite(site.length > 0 && site[0].shortName ? site[0].shortName : catName)
  }, [])

  return (
    <>
      <div className={PopupStyles.Underlay} />
      <div className={PopupStyles.Popup}>
        <div className={PopupStyles.Img}>
          <img src={post.spotlightDesktopImage ?? ''} alt={''} />
        </div>
        <div className={PopupStyles.Content}>
          <div
            onClick={() => setShowPopup(undefined)}
            className={PopupStyles.CloseButton}
          />
          <p className={PopupStyles.HeadingText}>
            Best Place To Live in {site} <span>Readers Vote</span>
          </p>
          {popupScreen === 0 && (
            <CastVote
              catName={catName}
              setPopupScreen={setPopupScreen}
              userEmail={userEmail}
              setUserEmail={setUserEmail}
              post={post}
              loggedIn={loggedIn}
            />
          )}
          {popupScreen === 1 && (
            // <EnterRT
            //   setPopup={setShowPopup}
            //   userEmail={userEmail}
            //   siteId={siteId}
            //   loggedIn={loggedIn}
            //   usr={usr}
            //   county={post.primaryCategory ?? 'error'}
            // />
            <ThankYou
              siteId={siteId ?? 1}
              setPopup={setShowPopup}
              county={site ?? 'error'}
            />
          )}
        </div>
      </div>
    </>
  )
}

export default Popup
